import { Diagnostic } from "@siteimprove/alfa-act";
import { Node } from "@siteimprove/alfa-aria";
/**
 * @public
 */
export class WithName extends Diagnostic {
    static of(message, name) {
        return name === undefined
            ? new Diagnostic(message)
            : new WithName(message, name);
    }
    _name;
    constructor(message, name) {
        super(message);
        this._name = name;
    }
    get name() {
        return this._name;
    }
    toJSON(options) {
        return {
            ...super.toJSON(options),
            name: this._name,
        };
    }
}
/**
 * @public
 */
(function (WithName) {
    /**
     * @public
     */
    function isWithName(value) {
        return value instanceof WithName;
    }
    WithName.isWithName = isWithName;
    function getName(element, device) {
        return Node.from(element, device).name.map((x) => x.value);
    }
    WithName.getName = getName;
})(WithName || (WithName = {}));
//# sourceMappingURL=with-name.js.map